import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  userInfo: {},
  xAuth: {},
  jssdkEnabled: false
}

const store = new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  strict: debug,
  plugins: [
    // createPersistedState({
    //   paths: ['xAuth', 'userInfo']
    // })
  ]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js